import { render } from "./OtherCTA.vue?vue&type=template&id=dd8b10ca"
const script = {}

import "./OtherCTA.vue?vue&type=style&index=0&id=dd8b10ca&lang=css"

import exportComponent from "C:\\Users\\Urakehn\\Documents\\Developpement\\R42\\EasyProf_landing\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__